/**
 * @desc 校验采购退货拣货单批次参数
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutPlanSkuBatchCheckRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/fulfilment/outPlanSkuBatchCheck`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
